export enum LeadType
{
    self = 'Self',
    child = 'Child',
    family = 'Family',
}

export enum AgeGroup
{
    band1 = '3-5 years',
    band2 = '6-12 years',
    band3 = '13-17 years',
    band4 = '18+ years'
}

export enum Gender
{
    male = 'Male',
    female = 'Female'
}

export enum Interest
{
    fitness = 'Fitness',
    selfDefence = 'Self Defence',
    selfDiscipline = 'Self Discipline',
    confidence = 'Confidence',
    competition = 'Competition',
}

export enum InterestTimeline
{
    justNow = 'Just Now',
    recently = 'Recently',
    someTime = 'For Some Time',
    always = 'Always',
}

export enum FamilyOption
{
    yes = "Yes, that's a great idea",
    no = "Not really",
}

export enum Introduction
{
    lead = 'Lead',
    salesperson = 'Salesperson'
}

export enum Dojo
{
    wollongong = 'Wollongong',
    albionParkRail = 'Albion Park Rail',
    mossVale = 'Moss Vale',
    mittagong = 'Mittagong',
    vincentia = 'Vincentia',
    bomaderry = 'Bomaderry'
}

export enum Outcome
{
    signup = 'Signup',
    notInterested = 'Not Interested',
    thinkAboutIt = "I'll Think About It",
}

export const LeadOptions = {

    greeting: [
        { value: true, title: 'Yes please' },
        { value: false, title: 'No thank you' },
    ],

    leadType: [
        { value: LeadType.self, title: 'Myself' },
        { value: LeadType.child, title: 'My Child' },
        { value: LeadType.family, title: 'My Family' },
    ],

    ageGroup: [
        { value: AgeGroup.band1, title: '3 - 5 years' },
        { value: AgeGroup.band2, title: '6 - 12 years' },
        { value: AgeGroup.band3, title: '13 - 17 years' },
        { value: AgeGroup.band4, title: '18+ years' },
    ],

    gender: [
        { value: Gender.male, title: 'Male' },
        { value: Gender.female, title: 'Female' },
    ],

    interest: [
        { value: Interest.fitness, title: 'Fitness' },
        { value: Interest.selfDefence, title: 'Self Defence' },
        { value: Interest.confidence, title: 'Confidence' },
        { value: Interest.selfDiscipline, title: 'Self Discipline' },
        { value: Interest.competition, title: 'Competition' },
    ],

    interestTimeline: [
        { value: InterestTimeline.justNow, title: 'Just now' },
        { value: InterestTimeline.recently, title: 'Recently' },
        { value: InterestTimeline.someTime, title: 'For some time' },
        { value: InterestTimeline.always, title: 'Always been interested in Karate' },
    ],

    familyOption: [
        { value: FamilyOption.no, title: 'Not really' },
        { value: FamilyOption.yes, title: "Yes, that's a great idea" },
    ],

    introduction: [
        { value: Introduction.lead, title: 'Approached By Lead' },
        { value: Introduction.salesperson, title: 'Approached By Salesperson' },
    ],

    dojo: [
        { value: Dojo.wollongong, title: 'Wollongong' },
        { value: Dojo.albionParkRail, title: 'Albion Park Rail' },
        { value: Dojo.mossVale, title: 'Moss Vale' },
        { value: Dojo.mittagong, title: 'Mittagong' },
        { value: Dojo.vincentia, title: 'Vincentia' },
        { value: Dojo.bomaderry, title: 'Bomaderry' },
    ],

    outcome: [
        { value: Outcome.signup, title: 'Sign Up' },
        { value: Outcome.thinkAboutIt, title: "I'll Think About It" },
        { value: Outcome.notInterested, title: "Not Interested" },
    ],
}